export default __webpack_public_path__ + "static/all-in-one-mobile-2e24f08fcde9e15e14799d6c96b3e86f.svg";